// Промо-страница поиска дублей.

import calculator from "../clean/calculator";
import MottoView from "../components/motto";
import paymentBlock from "../payments/payment-block";

const $ = window.jQuery;

$(() => {
    MottoView();
    calculator.Calculator($(".js-calculator")[0]);
});

export default {};
